import axios from "axios";
import { TOKEN_KEY } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Dealership API — namespaced under /api/dealership, reusing the base app's auth token.
const api = axios.create({
  baseURL: `${BACKEND_URL}/api/dealership`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(Number(n || 0));

export default api;
